import React, { useEffect, useState } from "react";
import { ContentContainer } from "../../../../../components/layout";
import {
  Breadcrumbs,
  Button,
  Modal,
  Select,
} from "../../../../../components/core";
import PickupFeesTable from "../user-fees/pick-up-fees-table";
import { useDispatch, useSelector } from "react-redux";
import { useLazyQuery, useQuery, useMutation } from "@apollo/client";
import { handleAddDataItemReducer } from "../../../../../features/locker-fees/add-user-fees/add-user-fees-slice";
import { useNavigate, useParams } from "react-router-dom";
import {
  ADD_USER_PICKUP_FEE,
  ADD_USER_SHIPOUT_FEE_BULK,
  LOCKER_TYPES,
  LOCKER_USER_TYPE,
  UPDATE_PARTNER_SHIPOUT_FEE,
  UPDATE_USER_PICKUP_FEE,
  UPDATE_USER_SHIPOUT_FEE,
  USER_PICKUP_FEES,
  USER_SHIPOUT_FEES,
} from "../../../../../constants/graphql/locker-queries";
import { Strings } from "../../../../../constants/strings";
import ShipoutFeesTable from "../user-fees/rejected-shipout-fees";
import useSidebarStore from "../../../../../zustand/stores/sidebar-store";
const breadcrumbItems = [
  {
    label: "Locker Fees",
    path: `/locker-fees/`,
  },
  { label: "Edit User Fee", path: "#" },
];
export default function EditUserFees() {
  const navigate = useNavigate();
  const accessPermission = useSelector(
    (state) => state.accessPermissions.accessPermissions
  );
  const dispatch = useDispatch();
  const { lockerTypeId, userTypeId } = useParams();
  const addDataItem = useSelector((state) => state.addUserFee.addDataItem);
  // Local States
  const [lockerTypeList, setLockerTypeList] = React.useState([]);
  const [userTypeList, setUserTypeList] = React.useState([]);
  const [userPickupFeesList, setUserPickupFeesList] = React.useState([]);
  const [userPickupFeesListOriginal, setUserPickupFeesListOriginal] =
    React.useState([]);
  const [userShipoutFeesList, setUserShipoutFeesList] = React.useState([]);
  const [userShipoutFeesListOriginal, setUserShipoutFeesListOriginal] =
    React.useState([]);
  const [addedPickupFees, setAddedPickupFees] = React.useState([]);
  const [addedShipoutFees, setAddedShipoutFees] = React.useState([]);
  const [changesMade, setChangesMade] = useState(false);

  const [validation, setValidation] = React.useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "",
    message: "",
    open: false,
  });
  // Graphql
  const lockerTypes = useQuery(LOCKER_TYPES, {
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
    },
  });
  const userTypes = useQuery(LOCKER_USER_TYPE, {
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
    },
  });
  const userPickupFees = useQuery(USER_PICKUP_FEES, {
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
      lockerTypeId: lockerTypeId,
      userTypeId: userTypeId,
    },
  });
  const userShipoutFees = useQuery(USER_SHIPOUT_FEES, {
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
      lockerTypeId: lockerTypeId,
      userTypeId: userTypeId,
    },
  });
  const [updateUserPickupFees] = useMutation(UPDATE_USER_PICKUP_FEE);
  const [updateUserShipoutFees] = useMutation(UPDATE_USER_SHIPOUT_FEE);
  const [addUserPickupFee] = useMutation(ADD_USER_PICKUP_FEE);
  const [addUserShipoutFee] = useMutation(ADD_USER_SHIPOUT_FEE_BULK);

  // zustand
  const pendingNavigation = useSidebarStore((state) => state.pendingNavigation);
  const setPendingNavigation = useSidebarStore(
    (state) => state.setPendingNavigation
  );
  const activeSubItem = useSidebarStore((state) => state.activeSubItem);
  const setActiveSubItem = useSidebarStore((state) => state.setActiveSubItem);

  // Handle Changes
  const handleAddDataItem = () => {
    let tempArr = [...addedPickupFees];
    tempArr.push({
      doorSizeId: "-1",
      initialFee: "", // ← Empty string instead of 1
      addInitialFreeHours: "", // ← Empty string instead of 1
      excessFeePerInc: "", // ← Empty string instead of 1
      incByHours: "", // ← Empty string instead of 1
      maxOverstayCharge: "", // ← Empty string instead of 1
    });
    setAddedPickupFees(tempArr);
    setChangesMade(true);
  };
  const handleAddShipoutItem = () => {
    let tempArr = [...addedShipoutFees];
    tempArr.push({
      doorSizeId: "-1",
      initialReturnFee: "",
      addInitialFreeHours: "",
      excessFeePerInc: "",
      incByHours: "",
      maxOverstayCharge: "",
    });
    setAddedShipoutFees(tempArr);
    setChangesMade(true);
  };
  const handleOnEditItem = (event) => {};
  const handleOnChange = () => {};
  const handleModifyAddedItems = (event) => {
    const { name, value, id } = event.target;
    // console.log("handleModifyAddedItems - Before update:", {
    //   name,
    //   value,
    //   index,
    //   currentValue: addedPickupFees[index]?.[name],
    // });

    let tempArr = [...addedPickupFees];
    tempArr[id][name] = value;

    console.log("handleModifyAddedItems - After update:", {
      updatedValue: tempArr[id][name],
      fullObject: tempArr[id],
    });

    setAddedPickupFees(tempArr);
    setChangesMade(true);
  };
  const handleModifyAddedShipoutItems = (event, index) => {
    const { name, value } = event.target;
    let tempArr = [...addedShipoutFees];
    tempArr[index][name] = value;
    setAddedShipoutFees(tempArr);
    setChangesMade(true);
  };
  const handleEditPickupFees = (event, index) => {
    const { name, value } = event.target;
    let tempArr = [...userPickupFeesList];
    tempArr[index][name] = value;
    setUserPickupFeesList(tempArr);
    setChangesMade(true);
  };
  const handleEditShipoutFees = (event, index) => {
    const { name, value } = event.target;
    let tempArr = [...userShipoutFeesList];
    tempArr[index][name] = value;
    setUserShipoutFeesList(tempArr);
    setChangesMade(true);
  };
  const handleSaveChanges = () => {
    let tempUserPickupFeeList = [...userPickupFeesList];
    let tempUserShipoutFeeList = [...userShipoutFeesList];
    tempUserPickupFeeList = tempUserPickupFeeList.map((obj) => ({
      ...obj,
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
      userTypeId: userTypeId,
      lockerTypeId: lockerTypeId,
    }));
    tempUserShipoutFeeList = tempUserShipoutFeeList.map((obj) => ({
      ...obj,
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
      userTypeId: userTypeId,
      lockerTypeId: lockerTypeId,
    }));
    let tempAddUserPickupFeeList = addedPickupFees.map((obj) => ({
      ...obj,
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
      userTypeId: userTypeId,
      lockerTypeId: lockerTypeId,
    }));
    let tempAddUserShipoutFeeList = addedShipoutFees.map((obj) => ({
      ...obj,
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
      userTypeId: userTypeId,
      lockerTypeId: lockerTypeId,
    }));
    let filteredEmptyDoorSize = [
      ...tempUserPickupFeeList,
      ...tempAddUserPickupFeeList,
    ].filter((x) => x.doorSizeId === "-1");
    let filteredEmptyDoorSizeShipout = [
      ...tempUserShipoutFeeList,
      ...tempAddUserShipoutFeeList,
    ].filter((x) => x.doorSizeId === "-1");
    let filteredDuplicateDoorSize = [
      ...tempUserPickupFeeList,
      ...tempAddUserPickupFeeList,
    ].filter(
      (x, i, self) => self.findIndex((y) => y.doorSizeId === x.doorSizeId) !== i
    );
    let filteredDuplicateDoorSizeShipout = [
      ...tempUserShipoutFeeList,
      ...tempAddUserShipoutFeeList,
    ].filter(
      (x, i, self) => self.findIndex((y) => y.doorSizeId === x.doorSizeId) !== i
    );

    if (
      filteredEmptyDoorSize.length > 0 ||
      filteredEmptyDoorSizeShipout.length > 0
    ) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Empty field error",
        message: "Door size is required.",
        open: true,
        actions: (
          <div className="w-full">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
    } else if (
      filteredDuplicateDoorSize.length > 0 ||
      filteredDuplicateDoorSizeShipout.length > 0
    ) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: Strings.popup_error_title_duplicate,
        message: "There is duplicate door size in your entry.",
        open: true,
        actions: (
          <div className="w-full">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
    } else {
      updateUserPickupFees({
        variables: {
          userPickupFees: tempUserPickupFeeList,
        },
      })
        .then((data) => {
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
            title: "Success",
            message: "Successfully saved changes.",
            open: true,
            actions: (
              <div className="w-full">
                <Button
                  onClick={() => {
                    setValidation({ open: false });
                    window.location.reload();
                  }}
                  value={"OK"}
                  className={"p-2 w-full"}
                />
              </div>
            ),
          });
        })
        .catch((e) => console.log(e));
      updateUserShipoutFees({
        variables: {
          userShipoutFees: tempUserShipoutFeeList,
        },
      })
        .then((data) => {
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
            title: "Success",
            message: "Successfully saved changes.",
            open: true,
            actions: (
              <div className="w-full">
                <Button
                  onClick={() => setValidation({ open: false })}
                  value={"OK"}
                  className={"p-2 w-full"}
                />
              </div>
            ),
          });
        })
        .catch((e) => console.log(e));
      addUserPickupFee({
        variables: {
          userPickupFees: tempAddUserPickupFeeList,
        },
      })
        .then((data) => {
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
            title: "Success",
            message: "Successfully saved changes.",
            open: true,
            actions: (
              <div className="w-full">
                <Button
                  onClick={() => setValidation({ open: false })}
                  value={"OK"}
                  className={"p-2 w-full"}
                />
              </div>
            ),
          });
        })
        .catch((e) => console.log(e));
      addUserShipoutFee({
        variables: {
          userShipoutFees: tempAddUserShipoutFeeList,
        },
      })
        .then((data) => {
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
            title: "Success",
            message: "Successfully saved changes.",
            open: true,
            actions: (
              <div className="w-full">
                <Button
                  onClick={() => setValidation({ open: false })}
                  value={"OK"}
                  className={"p-2 w-full"}
                />
              </div>
            ),
          });
        })
        .catch((e) => console.log(e));
    }
  };
  const handleCancelChanges = () => {
    setValidation({ open: false });
  };
  // Use Effects
  React.useEffect(() => {
    if (lockerTypes.data) {
      let tempVar = [];
      lockerTypes.data.lockerTypes.forEach((element) => {
        tempVar.push({
          value: element.lockerTypeId,
          name: element.lockerType,
        });
      });

      setLockerTypeList(tempVar);
    }
  }, [lockerTypes.data]);
  React.useEffect(() => {
    if (userTypes.data) {
      let tempVar = [];
      userTypes.data.lockerUserTypes.forEach((element) => {
        tempVar.push({
          value: element.userTypeId,
          name: element.userType,
        });
      });

      setUserTypeList(tempVar);
    }
  }, [userTypes.data]);
  React.useEffect(() => {
    if (userPickupFees.data) {
      let tempVar = [];
      console.log(userPickupFees.data.userPickupFees);
      userPickupFees.data.userPickupFees.forEach((element) => {
        tempVar.push({
          doorSizeId: element.doorSize.doorSizeId,
          userPickupFeeId: element.userPickupFeeId,
          initialFee: element.initialFee,
          addInitialFreeHours: element.addInitialFreeHours,
          excessFeePerInc: element.excessFeePerInc,
          incByHours: element.incByHours,
          maxOverstayCharge: element.maxOverstayCharge,
        });
      });
      console.log(tempVar);
      setUserPickupFeesList(tempVar);
      setUserPickupFeesListOriginal(tempVar);
    }
  }, [userPickupFees.data]);
  React.useEffect(() => {
    if (userShipoutFees.data) {
      let tempVar = [];
      console.log(userShipoutFees.data.userShipoutFees);
      userShipoutFees.data.userShipoutFees.forEach((element) => {
        tempVar.push({
          doorSizeId: element.doorSize.doorSizeId,
          userShipoutFeeId: element.userShipoutFeeId,
          initialReturnFee: element.initialReturnFee,
          addInitialFreeHours: element.addInitialFreeHours,
          excessFeePerInc: element.excessFeePerInc,
          incByHours: element.incByHours,
          maxOverstayCharge: element.maxOverstayCharge,
        });
      });
      console.log(tempVar);
      setUserShipoutFeesList(tempVar);
      setUserShipoutFeesListOriginal(tempVar);
    }
  }, [userShipoutFees.data]);

  useEffect(() => {
    if (pendingNavigation !== null) {
      if (changesMade) {
        // setCancelDialogOpen(true);
        console.log("open dialog");
        setValidation({
          icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
          title: `${Strings.popup_confirm_cancel_title}?`,
          message: Strings.popup_confirm_cancel_massage,
          open: true,
          actions: (
            <div className="flex justify-between gap-3">
              <Button
                onClick={() => {
                  setValidation({ open: false });
                  // window.location.reload();
                  setPendingNavigation(null);
                  setActiveSubItem(activeSubItem);
                }}
                value={"No"}
                className={"p-2 w-full"}
              />
              <Button
                onClick={() => {
                  navigate(pendingNavigation);
                  setPendingNavigation(null);
                }}
                value={"Yes"}
                className={"p-2 w-full"}
              />
            </div>
          ),
        });
      } else {
        navigate(pendingNavigation);
        setPendingNavigation(null);
      }
    }
  }, [pendingNavigation, changesMade]);
  return (
    <div>
      <Breadcrumbs items={breadcrumbItems} />
      <ContentContainer containerTitle={"Locker Fees"}>
        <div className="left w-1/2 grid grid-cols-2 gap-x-2 gap-y-6 pr-2">
          <p className="my-auto">Locker Type:</p>
          <p className="font-bold">
            {/* {partnerList.find((x) => x.value === branchProfile.partnerId) &&
              partnerList.find((x) => x.value === branchProfile.partnerId).name} */}
            {lockerTypeList.find((x) => x.value === lockerTypeId) &&
              lockerTypeList.find((x) => x.value === lockerTypeId).name}
          </p>
          <p className="my-auto">User Type:</p>
          <p className="font-bold">
            {userTypeList.find((x) => x.value === userTypeId) &&
              userTypeList.find((x) => x.value === userTypeId).name}
          </p>
        </div>
        <PickupFeesTable
          disabled={
            accessPermission.lockerFees === 1 ||
            accessPermission.lockerFees === "1"
          }
          data={userPickupFeesList}
          handleAddDataItem={handleAddDataItem}
          handleModifyAddedItems={handleModifyAddedItems}
          addedData={addedPickupFees}
          handleEditData={handleEditPickupFees}
          lockerType={
            lockerTypeList.find((x) => x.value === lockerTypeId)
              ? lockerTypeList.find((x) => x.value === lockerTypeId).name
              : ""
          }
          userType={
            userTypeList.find((x) => x.value === userTypeId)
              ? userTypeList.find((x) => x.value === userTypeId).name
              : ""
          }
        />
        <ShipoutFeesTable
          disabled={
            accessPermission.lockerFees === 1 ||
            accessPermission.lockerFees === "1"
          }
          data={userShipoutFeesList}
          addedData={addedShipoutFees}
          handleAddDataItem={handleAddShipoutItem}
          handleModifyAddedItems={handleModifyAddedShipoutItems}
          handleEditData={handleEditShipoutFees}
          lockerType={
            lockerTypeList.find((x) => x.value === lockerTypeId)
              ? lockerTypeList.find((x) => x.value === lockerTypeId).name
              : ""
          }
          userType={
            userTypeList.find((x) => x.value === userTypeId)
              ? userTypeList.find((x) => x.value === userTypeId).name
              : ""
          }
        />
        {changesMade && (
          <div className="grid grid-cols-2 gap-2 w-1/4">
            {/* <div>hello</div> */}
            <Button
              value={"Cancel Changes"}
              disabled={
                accessPermission.lockerFees === 1 ||
                accessPermission.lockerFees === "1"
              }
              className={"p-2"}
              onClick={() => {
                setValidation({
                  icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
                  title: Strings.popup_confirm_cancel_title,
                  message: Strings.popup_confirm_cancel_massage,
                  open: true,
                  actions: (
                    <div className="grid grid-cols-2 gap-2">
                      <Button
                        onClick={() => setValidation({ open: false })}
                        value={"No"}
                        className={"p-2 w-full"}
                      />
                      <Button
                        onClick={handleCancelChanges}
                        value={"Yes"}
                        className={"p-2 w-full"}
                      />
                    </div>
                  ),
                });
              }}
            />
            <Button
              value={"Save Changes"}
              disabled={
                accessPermission.lockerFees === 1 ||
                accessPermission.lockerFees === "1"
              }
              className={"p-2"}
              onClick={() => {
                setValidation({
                  icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
                  title: Strings.popup_confirm_save_title,
                  message: Strings.popup_confirm_save_massage,
                  open: true,
                  actions: (
                    <div className="grid grid-cols-2 gap-2">
                      <Button
                        onClick={() => setValidation({ open: false })}
                        value={"No"}
                        className={"p-2 w-full"}
                      />
                      <Button
                        onClick={handleSaveChanges}
                        value={"Yes"}
                        className={"p-2 w-full"}
                      />
                    </div>
                  ),
                });
              }}
            />
          </div>
        )}
        <Modal
          icon={validation.icon}
          title={validation.title}
          message={validation.message}
          open={validation.open}
          actions={validation.actions}
        />
      </ContentContainer>
    </div>
  );
}
